import React, { useEffect } from "react";
import Section from "../ui/section";
import ChawkBig from "../ui/icons/chawk-big";
import Facebook from "../ui/icons/facebook";
import Pinterest from "../ui/icons/pinterest";
import Linkedin from "../ui/icons/linkedin";
import Whatsapp from "../ui/icons/whatsapp";
import Location from "../ui/icons/location";
import Instagram from "../ui/icons/instagram";
import Email from "../ui/icons/email";
import Link from "next/link";
import { useUI } from "@/contexts/ui.context";
import Subscribe from "../ui/subscribe-button";
import { useRouter } from "next/router";
import GoToTopButton from "@/components/footer/gototop";



export default function Footer() {
  // const { loader, setLoader } = useUI();
  const router = useRouter();

  // useEffect(() => {
  // }, [loader, setLoader]);

  const socials = [
    {
      link: "mailto:sales@chalkstudio.design?subject=Hello",
      icon: <Email />,
      ariaLabel: "Email Button",
    },
    {
      link: "https://www.linkedin.com/company/chalkstudio-design/?originalSubdomain=in",
      icon: <Linkedin />,
      ariaLabel: "Linkedin Button",
    },
    {
      link: "https://instagram.com/chalkstudio.design?igshid=pvatrq7m4wxm",
      icon: <Instagram />,
      ariaLabel: "Instagram Button",
    },
    {
      link: "https://www.facebook.com/chalkstudiodesign/",
      icon: <Facebook />,
      ariaLabel: "Facebook Button",
    },
    {
      link: "https://wa.link/jnn17z",
      icon: <Whatsapp />,
      ariaLabel: "Whatsapp Button",
    },
    {
      link: "https://maps.app.goo.gl/oCJkH7WPuVefRzbNA",
      icon: <Location />,
      ariaLabel: "Location Button",
    },
  ];
  return (
    // !loader && (
    router?.pathname != "/thankyou" && (
      <Section className="bg-[#F6F5F1] md:!pb-8 !pb-12 relative z-[100] border-t-[1px] border-darkGrey/10">
        <ChawkBig />
        <div className="flex lg:flex-row flex-col w-full md:mt-12 mt-8 md:gap-4 gap-3">
          <div className="flex flex-col lg:items-start lg:justify-end items-center justify-center gap-8 shrink-0">
            {router?.pathname !== "/" && <Subscribe />}
            <div className="flex flex-row flex-wrap items-center md:justify-start justify-center gap-5 max-[575px]:!gap-3">
              <Link
                href="/blogs"
                className="text-darkGrey font-havletica font-light text-sm hover:text-[#D5D1C1] transition-all duration-300 ease"
              >
                Blogs
              </Link>
              <Link
                href="/careers"
                className="text-darkGrey font-havletica font-light text-sm hover:text-[#D5D1C1] transition-all duration-300 ease"
              >
                Careers
              </Link>
              <Link
                href="/about"
                className="text-darkGrey font-havletica font-light text-sm hover:text-[#D5D1C1] transition-all duration-300 ease"
              >
                About Us
              </Link>
              <Link
                href="tel:+919599197669"
                className="text-darkGrey font-havletica font-light text-sm hover:text-[#D5D1C1] transition-all duration-300 ease"
              >
                Call - +91 95991 97669
              </Link>

              {/* <Link
                href="tel:+919599197669"
                className="text-darkGrey font-havletica font-light text-sm hover:text-[#D5D1C1] transition-all duration-300 ease"
              >
                 +91 9599197669
              </Link> */}
              
            </div>
          </div>
          <div className="flex flex-col lg:items-end lg:justify-start items-center justify-center w-full gap-8">
            <div className="flex flex-row md:gap-4 gap-3">
              {socials?.map((row, key) => (
                <a
                  href={row.link}
                  target="_blank"
                  rel="nofollow"
                  key={"social" + key}
                  aria-label={row?.ariaLabel}
                  className="hover:text-darkGrey text-[#e9e7de] transition-all duration-300 ease"
                >
                  {row?.icon}
                </a>
              ))}
            </div>

            <p className="text-sm font-light text-darkGrey text-right font-havletica">
              Copyright 2024 LC. 2023 Chalk Studio.
            </p>
          </div>
        </div>
        <GoToTopButton />
      </Section>

    )
  );
}
